
export function formatFileTooltipItems(records: Array<Record<string, unknown>>) {
  return records.map((record, index) => {
    const originalRecord = record;
    const mapping = record.swivuDocumentRecordMapping as Record<string, unknown>;
    const description = (mapping.name as string) || "";
    const truncatedDescription =
      description.length > 50 ? description.substring(0, 50) + "..." : description;

    return {
      tag: "div",
      dataset: {
        documentId: originalRecord.id,
        source: mapping.source,
      },
      class: `tooltip-contact-container flex flex-col gap-2 ${index > 0 ? "pt-3 mt-3 border-t border-border" : ""}`,
      children: [
        {
          tag: "div",
          class:
            "contact-pill contact-header font-medium text-sm cursor-pointer hover:bg-accent/80 transition-colors rounded-md px-3 py-2",
          html: `
              <div class="flex items-center gap-2">
                <img
                  src="${mapping.thumbnailImageUrl}"
                  alt="${mapping.name}"
                  class="w-10 h-10 rounded border border-border object-cover flex-shrink-0"
                  onerror="this.src='https://www.iconpacks.net/icons/2/free-file-icon-1453-thumb.png'"
                />
                <div class="flex-1 min-w-0 flex flex-col gap-1">
                  <div class="truncate text-sm font-medium text-foreground">${truncatedDescription || "Untitled Media"}</div>
                  <div class="truncate text-xs text-muted-foreground">Added By: ${mapping.addedBy || "N/A"}</div>
                </div>
              </div>
            `,
        },
      ],
    };
  });
}

export function handleFileTooltipClick(
  _event: { target: EventTarget | null },
  column: {
    onDocumentTimeout?: ReturnType<typeof setTimeout>;
  }
) {
  if (column.onDocumentTimeout) clearTimeout(column.onDocumentTimeout);
}
